import { i18n } from '../../i18n/translate.js';
import { copyText } from '../../utils/CopyUtil.js';
import { displaySuccessMessage, displayErrorMessage } from '../../actions/messagesActions.js';

var copyToClipboard = function copyToClipboard(value) {
  var success = copyText(value);

  if (success) {
    displaySuccessMessage(i18n.t('Copied!'));
  } else {
    displayErrorMessage(i18n.t('Unable to copy'));
  }
};

export { copyToClipboard };